// Shared card chrome for the receiving queue's cards. Extracted from UnifiedOrderCard so
// the 門市 card renders in the same visual language as a customer card (Magnus 2026-09-22:
// 「the 門市 card is very ugly.. can't u make it like the other receiving order cards?」).
// Same tokens, one definition — the two cards cannot drift apart.
export const S = {
  card: {
    borderRadius: '14px',
    border: '1px solid #e8e5e1',
    bgcolor: '#ffffff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
    overflow: 'visible',
    mb: 2.5,
    transition: 'box-shadow 0.2s ease',
    '&:hover': { boxShadow: '0 3px 12px rgba(0,0,0,0.06)' },
  },
  cardReady: { borderLeft: '4px solid #22c55e' },
  cardPartial: { borderLeft: '4px solid #f59e0b' },
  cardShipped: { borderLeft: '4px solid #3b82f6' },
  tableHeader: {
    bgcolor: '#fafaf8',
    '& .MuiTableCell-head': {
      fontWeight: 700, fontSize: '0.72rem', textTransform: 'uppercase' as const,
      letterSpacing: '0.05em', color: '#8c8580', borderBottom: '2px solid #e8e5e1', py: 1.5, px: 2,
    },
  },
  tableRow: (received: boolean, outOfStock?: boolean) => ({
    bgcolor: outOfStock ? '#fff8e1' : received ? '#f8fdf6' : 'transparent',
    transition: 'background-color 0.15s ease',
    '&:hover': { bgcolor: outOfStock ? '#fff3e0' : received ? '#f0fdf4' : '#fafaf8' },
    '& .MuiTableCell-root': { borderBottom: '1px solid #f0eeea', py: 2.5, px: 2, fontSize: '0.9rem' },
  }),
  metaChip: {
    display: 'inline-flex', alignItems: 'center', gap: 0.5,
    px: 1.25, py: 0.35, borderRadius: '8px',
    bgcolor: '#f5f3f0', color: '#78716c', fontSize: '0.78rem', fontWeight: 500,
  },
  btn: {
    textTransform: 'none' as const, borderRadius: '10px', fontWeight: 600, fontSize: '0.82rem',
    px: 2, py: 0.75, boxShadow: 'none',
  },
};
